import models from "@aeo/core/models";

export const checkApplicationState = (
  arr: models.ApplicationState[],
  state: models.ApplicationState,
) => arr.includes(state);
